import { styled, SxProps, keyframes, useForkRef } from '@mui/material'
import { ForwardedRef, forwardRef, RefObject, useEffect, useRef } from 'react'

export const HotSpot = forwardRef(function BeaconComponent(
  props: {
    'aria-label'?: string
    onClick?: () => unknown
    onMouseEnter?: () => unknown
    className?: string
    sx?: SxProps
    containerRef?: RefObject<HTMLElement>
  },
  ref: ForwardedRef<HTMLSpanElement>,
) {
  const innerRef = useRef<HTMLSpanElement>(null)
  const handleRef = useForkRef(ref, innerRef)

  useEffect(() => {
    const container = props.containerRef?.current
    if (container) {
      const handleMouseEnter = () => {
        innerRef.current?.classList.add('pause-animation')
      }
      const handleMouseLeave = () => {
        innerRef.current?.classList.remove('pause-animation')
      }

      container.addEventListener('mouseenter', handleMouseEnter)
      container.addEventListener('mouseleave', handleMouseLeave)

      return () => {
        container.removeEventListener('mouseenter', handleMouseEnter)
        container.removeEventListener('mouseleave', handleMouseLeave)
      }
    }
  }, [])

  return (
    <Root
      ref={handleRef}
      onClick={props.onClick}
      aria-label={props['aria-label']}
      onMouseEnter={props.onMouseEnter}
      className={props.className}
      sx={props.sx}
    >
      <Beacon />
    </Root>
  )
})

export const Root = styled('span')`
  animation: pulse 1.5s ease-in-out infinite;
  color: #ffa100;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 23px;
  width: 23px;
  cursor: pointer;
  border: 2px solid currentColor;
  box-sizing: border-box;
  box-shadow: ${({ theme }) => theme.shadows[2]};

  &.pause-animation {
    animation-play-state: paused;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }

    10% {
      transform: scale(1);
    }

    55% {
      color: #ffb700;
      transform: scale(1.1);
    }
  }
`

const Beacon = styled('span')`
  background-color: currentColor;
  height: 15px;
  width: 15px;
  border-radius: 50%;
`
